import React from 'react';
import Icon from '../../../components/AppIcon';

const ResponseMetricsCard = ({ language, metrics }) => {
  const content = {
    en: {
      title: 'Response Metrics',
      avgResponseTime: 'Avg Response Time',
      hours: 'hours',
      benchmark: 'Industry Benchmark: 24h',
      performance: 'Performance',
      excellent: 'Excellent',
      good: 'Good',
      needsImprovement: 'Needs Improvement',
      totalInquiries: 'Total Inquiries',
      responseRate: 'Response Rate'
    },
    zh: {
      title: '响应指标',
      avgResponseTime: '平均响应时间',
      hours: '小时',
      benchmark: '行业基准：24小时',
      performance: '表现',
      excellent: '优秀',
      good: '良好',
      needsImprovement: '需要改进',
      totalInquiries: '总询问数',
      responseRate: '响应率'
    }
  };

  const t = content?.[language];

  const avgResponseHours = Number(metrics?.avgResponseHours || 0);
  const totalInquiries = Number(metrics?.totalInquiries || 0);
  const responseRate = totalInquiries > 0 ? 100 : 0;

  const getPerformanceStatus = () => {
    if (avgResponseHours <= 12) return { label: t?.excellent, color: 'text-success' };
    if (avgResponseHours <= 24) return { label: t?.good, color: 'text-primary' };
    return { label: t?.needsImprovement, color: 'text-destructive' };
  };

  const performance = getPerformanceStatus();

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="Clock" size={20} className="text-primary" />
        <h3 className="text-lg font-heading font-semibold text-foreground">{t?.title}</h3>
      </div>

      <div className="space-y-6">
        {/* Average Response Time */}
        <div>
          <div className="flex items-baseline gap-2 mb-2">
            <span className="text-3xl font-bold text-foreground">
              {avgResponseHours?.toFixed(1)}
            </span>
            <span className="text-muted-foreground">{t?.hours}</span>
          </div>
          <p className="text-sm text-muted-foreground mb-3">{t?.avgResponseTime}</p>
          <div className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground">{t?.performance}:</span>
            <span className={`text-xs font-medium ${performance?.color}`}>
              {performance?.label}
            </span>
          </div>
        </div>

        {/* Benchmark */}
        <div className="border-t border-border pt-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
            <Icon name="Target" size={16} />
            <span>{t?.benchmark}</span>
          </div>
          <div className="w-full bg-muted rounded-full h-2">
            <div 
              className="bg-primary rounded-full h-2 transition-all"
              style={{ width: `${Math.min((24 / Math.max(avgResponseHours, 1)) * 100, 100)}%` }}
            />
          </div>
        </div>

        {/* Additional Metrics */}
        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border">
          <div>
            <p className="text-2xl font-bold text-foreground">{totalInquiries}</p>
            <p className="text-xs text-muted-foreground">{t?.totalInquiries}</p>
          </div>
          <div>
            <p className="text-2xl font-bold text-foreground">{responseRate}%</p>
            <p className="text-xs text-muted-foreground">{t?.responseRate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponseMetricsCard;